export default __webpack_public_path__ + "static/media/tech-0-fig5.d8f9235e.png";